document.querySelectorAll('.RangeBase').forEach((RangeBase) => {
    const RangeBaseSteps = RangeBase.querySelectorAll('.RangeBase__steps span');
    const RangeBaseValue = RangeBase.querySelector('.RangeBase__value');
    const RangeBaseInput = RangeBase.querySelector('input');

    setValue(RangeBaseInput.value);
    RangeBaseInput.addEventListener('input', () => {
        setValue(RangeBaseInput.value);
    });
    RangeBaseInput.addEventListener('update', () => {
        setValue(RangeBaseInput.value);
    });

    RangeBaseSteps.forEach((step, i) => {
        step.addEventListener('click', () => {
            RangeBaseInput.value = (i + 1) * RangeBaseInput.step;
            setValue(RangeBaseInput.value);
        });
    });

    function setValue(valueRaw) {
        const proc = 100 / (RangeBaseInput.max - RangeBaseInput.min);
        const val = valueRaw - RangeBaseInput.min;
        RangeBaseValue.style.width = getWidth(val * proc * 0.99);

        const stepsActive = val / RangeBaseInput.step;
        RangeBaseSteps.forEach((step, i) => {
            if(i === stepsActive) {
                step.classList.add('RangeBase__edge');
            }
            else {
                step.classList.remove('RangeBase__edge');
            }
        })
    }

    function getWidth(val) {
        return `${isNaN(val) ? 0 : val}%`;
    }
})
